// @givmo/app-charity — `/org/activity`: the access event log, its own page (shell contract v3).
//
// Promoted from under the Apps page's switches; the sidebar is a home. The panel's heading is hidden
// so "Activity" renders once — the page title names it; the `<h2>` keeps its place in the heading
// outline for assistive technology.
//
// ⚠ THE GATE IS THE PAGE'S OWN CAPABILITY, `read_events` (wrapped at the route). The panel keeps
// its own read gate underneath.
//
// DATA CONTRACT: `page-org-activity` is the route's root; inside it the package's
// `org-console-events-*` family.

import { OrgAccessEventsPanel } from '@givmo/org-console';
import { testIdProp } from '@givmo/design-system';
import { PageShell } from '../../components/page-shell';
import { useOrgConsoleConfig } from '../org-console/use-org-console-config';

export function ActivityPage() {
  const config = useOrgConsoleConfig();

  return (
    <PageShell testId="page-org-activity" title="Activity">
      {config === null ? (
        <p className="font-sans text-s13 text-text-tertiary" {...testIdProp('activity-pending')}>
          Loading…
        </p>
      ) : (
        <OrgAccessEventsPanel config={config} headingHidden />
      )}
    </PageShell>
  );
}
